import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { Drawer as n } from "../../drawer/index.js";
import { Popover as r } from "../../popover/compound-popover.js";
import { XCloseIcon as i } from "@systemeio/icons";
import { twMerge as a } from "tailwind-merge";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { useMediaQuery as c } from "@systemeio/util";
//#region src/date-picker/primitive/popup.tsx
function l({ disabled: l, footer: u, trigger: d, triggerRender: f, open: p, title: m, popupClassName: h, contentClassName: g, footerClassName: _, children: v, onClose: y, onOpenChange: b }) {
	let { isMobile: x } = c();
	return x ? /* @__PURE__ */ s(n.Root, {
		open: p,
		onOpenChange: b,
		children: [/* @__PURE__ */ o(n.Trigger, {
			disabled: l,
			nativeButton: !f,
			render: f,
			children: d
		}), /* @__PURE__ */ s(n.Popup, {
			className: h,
			children: [
				(m || y) && /* @__PURE__ */ o(n.Header, { children: /* @__PURE__ */ s("div", {
					className: "flex w-full items-start gap-2",
					children: [/* @__PURE__ */ o("div", {
						className: "min-w-0 flex-1",
						children: m && /* @__PURE__ */ o(n.Title, { children: m })
					}), y && /* @__PURE__ */ o(n.Close, {
						"aria-label": "Close",
						render: /* @__PURE__ */ o(t, {
							size: "icon-sm",
							variant: "ghost-gray"
						}),
						children: /* @__PURE__ */ o(i, {})
					})]
				}) }),
				/* @__PURE__ */ o(n.Content, {
					className: a("gap-0 p-0", g),
					children: v
				}),
				u && /* @__PURE__ */ o(n.Footer, {
					className: _,
					children: u
				})
			]
		})]
	}) : /* @__PURE__ */ s(r.Root, {
		open: p,
		onOpenChange: b,
		children: [/* @__PURE__ */ o(r.Trigger, {
			disabled: l,
			nativeButton: !f,
			render: f,
			children: d
		}), /* @__PURE__ */ o(r.Portal, { children: /* @__PURE__ */ o(r.Positioner, {
			align: "center",
			side: "bottom",
			sideOffset: 8,
			children: /* @__PURE__ */ s(r.Popup, {
				className: e("w-fit max-w-none overflow-hidden", h),
				children: [/* @__PURE__ */ o("div", {
					className: e(g),
					children: v
				}), u && /* @__PURE__ */ o("div", {
					className: e("p-4", _),
					children: u
				})]
			})
		}) })]
	});
}
//#endregion
export { l as Popup };
